import axios from 'axios';
import urlUtil from 'url';
import { transformToProxyUrl, configProxyAxios, interceptOGCError } from './GeralUtils';
import { parseURN } from './CoordinatesUtils';
import { INFO_FORMATS } from './FeatureInfoUtils';
import { getIdentifyFlow } from './MapInfoUtils';
import { isString, isNil } from '@config/utils';

export const getFormatForResponse = (res, props) => {
    let {format, queryParams = {}} = res;
    queryParams = Object.keys(queryParams)
                          .reduce((destination, key) => {
                            destination[key.toUpperCase()] = queryParams[key];
                            return destination;
                          }, {});
    // handle WMS/WMTS.., and also WFS
    return queryParams.INFO_FORMAT
        || queryParams.INFOFORMAT
        || queryParams.OUTPUTFORMAT
        || format && INFO_FORMATS[format]
        || props.format;
};

export function getFeatureId(feature, property = null) {
    return feature ? (property ? feature?.properties[property] : (feature?.properties['id'] || feature?.properties['gid'] || feature.id)) : null;
}

export const getFeatureInfo = async (basePath, param, layer, {attachJSON, itemId = null} = {}) => {
    const defaultIdentifyFlow = async (params) => {
        const parsed = urlUtil.parse(basePath, true);
        const url = urlUtil.format(Object.assign({}, parsed, {
            query: Object.assign(params, parsed.query)
        }));
        return await axios.get(transformToProxyUrl(url), configProxyAxios(url))
    };
    const specificIdentifyFlow = (params) => getIdentifyFlow(layer, basePath, params);
    const retrieveFlow = getIdentifyFlow(layer, basePath, param)
    ? specificIdentifyFlow
    : defaultIdentifyFlow;

    return await (
        // default identify flow, valid for WMS/WMTS. It attach json data, if missing, for advanced features. TODO: make this specific by service, using layer info.
        (attachJSON && param.info_format !== "application/json" && param.outputFormat !== "application/json")
        // add to the flow data in JSON format for highlight/zoom to feature
            ? Observable.forkJoin(
                    retrieveFlow(param),
                    retrieveFlow({ ...param, info_format: "application/json" })
                        .map(res => res.data)
                        .catch(() => Observable.of({})) // errors on geometry retrieval are ignored
                ).map(([response, data]) => ({
                    ...response,
                    features: data && data.features && data.features.filter(f => !isNil(itemId) ? f.id === itemId : true),
                    featuresCrs: data && data.crs && parseURN(data.crs)
                }))
            // simply get the feature info, geometry is already there
            : retrieveFlow(param)
                .then(res => {
                    if(isString(res.data)){
                        let exceptions = interceptOGCError(res, false);
                        if(exceptions){
                            return {
                                data: res.data,
                                exceptions: exceptions,
                            }
                        }
                    }
                    return res.data;
                })
                .then((data = {}) => {
                    return {
                        data: isString(data) ?
                            data :
                            {
                                ...data,
                                features: data.features && data.features.filter(f => itemId ? f.id === itemId : true)
                            },
                        features: data.features && data.features.filter(f => itemId ? f.id === itemId : true),
                        featuresCrs: data && data.crs && parseURN(data.crs),
                    }
                })
    );
};